import { render } from "./MainServicePage.vue?vue&type=template&id=71452a48&scoped=true"
import script from "./MainServicePage.vue?vue&type=script&lang=js"
export * from "./MainServicePage.vue?vue&type=script&lang=js"

import "./MainServicePage.vue?vue&type=style&index=0&id=71452a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71452a48"]])

export default __exports__